import Questions from "pages/dashboard/shared/Questions/Questions";
import React from "react";

const AdminQuestions = () => {
  return <Questions />;
};

export default AdminQuestions;
